<template>
  <div :class="'theme' + themeSelect" v-loading="loading">
    <VipHeaderComposeDoc
      ref="headerComposeDoc"
      :title="title"
      @handleTitleChange="handleTitleChange"
      @handleExport="handleExport"
    />
    <div id="body">
      <div class="compose write-model">
        <div class="compose_main">
          <div class="tool-bar">
            <Toolbar
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
          </div>
          <div class="board">
            <div class="page" id="page">
              <Editor
                v-model="html"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
                @onChange="onChange"
              />
            </div>
            <div class="float-bar">
              <el-tooltip
                content="封面选择"
                popper-class="float-bar-tip"
                placement="left"
                effect="light"
              >
                <!-- <el-button @click="dialogFrontCover = true" type="text"> -->
                <el-button @click="showTips" type="text">
                  <img src="~@/assets/images/icon-compose-float1.png" alt="" />
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="目录选择"
                popper-class="float-bar-tip"
                placement="left"
                effect="light"
              >
                <el-button @click="handleCatalogClick" type="text">
                  <img src="~@/assets/images/icon-compose-float2.png" alt="" />
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="显示目录"
                popper-class="float-bar-tip"
                placement="left"
                effect="light"
              >
                <el-button
                  @click="floatBarLayerShow = !floatBarLayerShow"
                  :class="floatBarLayerShow ? 'is-active' : ''"
                  type="text"
                >
                  <img src="~@/assets/images/icon-compose-float3.png" alt="" />
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="封底选择"
                popper-class="float-bar-tip"
                placement="left"
                effect="light"
              >
                <!-- <el-button @click="dialogBackCover = true" type="text"> -->
                <el-button @click="showTips" type="text">
                  <img src="~@/assets/images/icon-compose-float4.png" alt="" />
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="设置"
                popper-class="float-bar-tip"
                placement="left"
                effect="light"
              >
                <el-button @click="dialogSetting = true" type="text">
                  <img src="~@/assets/images/icon-compose-float5.png" alt="" />
                </el-button>
              </el-tooltip>
            </div>
            <div
              :class="
                floatBarLayerShow
                  ? 'float-bar-layer is-active'
                  : 'float-bar-layer'
              "
            >
              <div class="catalog">
                <ul id="header-container" v-html="headerHTML"></ul>
              </div>
            </div>
            <div class="right-bar">
              <!-- <el-button
                @click="
                  rightBarBox == '1'
                    ? (rightBarBox = '0')
                    : (rightBarBox = '1');
                  rightBarBox == '1'
                    ? (rightBarLayerShow = true)
                    : (rightBarLayerShow = false);
                "
                :class="rightBarBox == 1 ? 'is-active' : ''"
                type="text"
              > -->
              <el-button
                @click="showTips"
                :class="rightBarBox == 1 ? 'is-active' : ''"
                type="text"
              >
                <img src="~@/assets/images/icon-compose-right1.png" alt="" />
                <span>我的素材</span>
              </el-button>
              <el-button
                @click="
                  rightBarBox == '2'
                    ? (rightBarBox = '0')
                    : (rightBarBox = '2');
                  rightBarBox == '2'
                    ? (rightBarLayerShow = true)
                    : (rightBarLayerShow = false);
                "
                :class="rightBarBox == 2 ? 'is-active' : ''"
                type="text"
              >
                <img src="~@/assets/images/icon-compose-right2.png" alt="" />
                <span>图谱搜索</span>
              </el-button>
              <el-button
                @click="
                  rightBarBox == '3'
                    ? (rightBarBox = '0')
                    : (rightBarBox = '3');
                  rightBarBox == '3'
                    ? (rightBarLayerShow = true)
                    : (rightBarLayerShow = false);
                "
                :class="rightBarBox == 3 ? 'is-active' : ''"
                type="text"
              >
                <img src="~@/assets/images/icon-compose-right3.png" alt="" />
                <span>文本检索</span>
              </el-button>
              <el-button
                @click="
                  rightBarBox == '4'
                    ? (rightBarBox = '0')
                    : (rightBarBox = '4');
                  rightBarBox == '4'
                    ? (rightBarLayerShow = true)
                    : (rightBarLayerShow = false);
                "
                :class="rightBarBox == 4 ? 'is-active' : ''"
                type="text"
              >
                <img src="~@/assets/images/icon-compose-right4.png" alt="" />
                <span>数据查找</span>
              </el-button>
              <el-button
                @click="
                  rightBarBox == '5'
                    ? (rightBarBox = '0')
                    : (rightBarBox = '5');
                  rightBarBox == '5'
                    ? (rightBarLayerShow = true)
                    : (rightBarLayerShow = false);
                "
                :class="rightBarBox == 5 ? 'is-active' : ''"
                type="text"
              >
                <img src="~@/assets/images/icon-compose-right5.png" alt="" />
                <span>学术翻译</span>
              </el-button>
            </div>
            <div
              :class="
                rightBarLayerShow
                  ? 'right-bar-layer is-active'
                  : 'right-bar-layer'
              "
            >
              <div v-if="rightBarBox == 1" class="r-box">
                <div class="r-box_content">
                  <div class="inner-search">
                    <el-input placeholder="请输入检索词">
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                  <div class="inner-tabs">
                    <el-tabs>
                      <el-tab-pane label="全部"></el-tab-pane>
                      <el-tab-pane label="研报"></el-tab-pane>
                      <el-tab-pane label="论文"></el-tab-pane>
                      <el-tab-pane label="专利"></el-tab-pane>
                      <el-tab-pane label="政策"></el-tab-pane>
                    </el-tabs>
                  </div>
                  <div class="article-list">
                    <div class="list-item" v-for="item in 5" :key="item">
                      <div class="title">
                        <span class="type">研报</span>
                        <a href="#"
                          >2022年新能源汽车（蔚来、理想、小鹏、哪吒）企业对比系列报告（一）：赛道阻力加…</a
                        >
                      </div>

                      <div class="intro">
                        明提供一种试管制备设备及其制备方法，该制备设备利用贴标装置包含有连动模块可连动定位单元，通过定位单元可放置一管体并微调该管体。
                      </div>
                      <div class="info">
                        <span class="t">
                          <img src="~@/assets/images/icon-time.png" alt="" />
                          2022/04/13
                        </span>
                        <span class="o">
                          <img src="~@/assets/images/icon-from.png" alt="" />
                          刘毅 东方财富
                        </span>
                        <span class="b">
                          <img src="~@/assets/images/icon-tag.png" alt="" />
                          标签
                        </span>
                      </div>

                      <div class="op">
                        <el-button>
                          <img src="~@/assets/images/icon-quote.png" alt="" />
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div class="list-bottom">
                    <el-pagination small layout="prev, pager, next" :total="50">
                    </el-pagination>
                  </div>
                </div>
              </div>
              <div v-else-if="rightBarBox == 2" class="r-box">
                <div class="r-box_content">
                  <div class="inner-search">
                    <el-input
                      v-model="imageText"
                      placeholder="请输入检索词"
                      @keyup.native.enter="handleImageSearch(true)"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                  <div class="pic-list" v-loading="imageLoading">
                    <div
                      class="no-data"
                      v-if="!imageRecords || imageRecords.length === 0"
                    >
                      <div class="tip">
                        <svg
                          t="1626241932884"
                          class="icon"
                          viewBox="0 0 1428 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2321"
                          width="60"
                          height="60"
                        >
                          <path
                            d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                            p-id="2322"
                          ></path>
                          <path
                            d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                            p-id="2323"
                          ></path>
                          <path
                            d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                            p-id="2324"
                          ></path>
                          <path
                            d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                            p-id="2325"
                          ></path>
                          <path
                            d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                            p-id="2326"
                          ></path>
                          <path
                            d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                            p-id="2327"
                          ></path>
                        </svg>
                        <div class="text">暂无数据</div>
                      </div>
                    </div>
                    <div
                      class="list-item"
                      v-for="(item, index) in imageRecords"
                      :key="index"
                    >
                      <div class="title">
                        <a
                          href="javascript:;"
                          @click="
                            handleOpenEditImg(item.picPath, item.picTitle)
                          "
                        >
                          {{ item.picTitle }}
                        </a>
                      </div>
                      <div class="pic">
                        <a
                          href="javascript:;"
                          @click="
                            handleOpenEditImg(item.picPath, item.picTitle)
                          "
                        >
                          <el-image
                            :src="item.picPath"
                            lazy
                            crossorigin="anonymous"
                          >
                            <div slot="error" style="margin-top: -120px">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="list-bottom" v-if="imageTotal > 0">
                    <el-pagination
                      small
                      layout="prev, pager, next"
                      :total="imageTotal"
                      :current-page="imagePageIndex"
                      @current-change="handleImageCurrentPageChange"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
              <div v-else-if="rightBarBox == 3" class="r-box">
                <div class="r-box_content">
                  <div class="inner-search">
                    <el-input
                      placeholder="请输入检索词"
                      v-model="paragraphText"
                      @keyup.native.enter="handleTextSearch(true)"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                  <div class="inner-tabs">
                    <el-tabs
                      v-model="activeTextSearchName"
                      @tab-click="handleTextSearchTabsClick"
                    >
                      <el-tab-pane label="研报" name="yb"></el-tab-pane>
                      <el-tab-pane label="论文" name="lw"></el-tab-pane>
                      <el-tab-pane label="专利" name="zl"></el-tab-pane>
                      <el-tab-pane label="政策" name="zc"></el-tab-pane>
                      <el-tab-pane label="资讯" name="zx"></el-tab-pane>
                    </el-tabs>
                  </div>
                  <div class="article-list" v-loading="paragraphLoading">
                    <template v-for="(item, index) in paragraphRecords">
                      <div
                        class="list-item"
                        :key="index"
                        v-if="activeTextSearchName === 'yb'"
                      >
                        <div class="title">
                          <span class="type">研报</span>
                          <el-tooltip
                            placement="bottom-start"
                            effect="light"
                            :content="item.reportTitle"
                          >
                            <a href="javascript:void(0);">
                              {{ cutstring(item.reportTitle, 38) }}
                            </a>
                          </el-tooltip>
                        </div>

                        <div class="intro">
                          <span
                            v-text="item.content"
                            v-if="item.showMore"
                          ></span>
                          <span
                            v-text="cutstring(item.content, 130)"
                            v-else
                          ></span>
                          <el-button
                            type="text"
                            @click="item.showMore = true"
                            v-if="!item.showMore"
                            class="show-more"
                          >
                            更多
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                        </div>

                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.reportDate, "YYYY-MM-DD") }}
                          </span>
                          <!-- <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            刘毅 东方财富
                          </span> -->
                          <span class="b">
                            <img src="~@/assets/images/icon-tag.png" alt="" />
                            {{ item.keyword.join(" ") }}
                          </span>
                        </div>

                        <div class="op">
                          <el-button @click="handleInsertText(item.content)">
                            <img src="~@/assets/images/icon-quote.png" alt="" />
                          </el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        :key="index"
                        v-if="activeTextSearchName === 'lw'"
                      >
                        <div class="title">
                          <span class="type">论文</span>
                          <el-tooltip
                            placement="bottom-start"
                            effect="light"
                            :content="item.title"
                          >
                            <a href="javascript:void(0);">
                              {{ cutstring(item.title, 38) }}
                            </a>
                          </el-tooltip>
                        </div>

                        <div class="intro">
                          <span
                            v-text="item.abstract"
                            v-if="item.showMore"
                          ></span>
                          <span
                            v-text="cutstring(item.abstract, 130)"
                            v-else
                          ></span>
                          <el-button
                            type="text"
                            @click="item.showMore = true"
                            v-if="!item.showMore"
                            class="show-more"
                          >
                            更多
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                        </div>

                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ item.year }}年
                          </span>
                          <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ item.organization.join(" ") }}
                          </span>
                          <!-- <span class="b">
                            <img src="~@/assets/images/icon-tag.png" alt="" />
                            {{ item.keyword.join(" ") }}
                          </span> -->
                        </div>

                        <div class="op">
                          <el-button @click="handleInsertText(item.abstract)">
                            <img src="~@/assets/images/icon-quote.png" alt="" />
                          </el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        :key="index"
                        v-else-if="activeTextSearchName === 'zl'"
                      >
                        <div class="title">
                          <span class="type">专利</span>
                          <el-tooltip
                            placement="bottom-start"
                            effect="light"
                            :content="clearHtml(item.title)"
                          >
                            <a
                              href="javascript:void(0);"
                              v-text="cutstring(clearHtml(item.title), 38)"
                            >
                            </a>
                          </el-tooltip>
                        </div>

                        <div class="intro">
                          <span
                            v-text="clearHtml(item.abs)"
                            v-if="item.showMore"
                          ></span>
                          <span
                            v-text="cutstring(clearHtml(item.abs), 130)"
                            v-else
                          ></span>
                          <el-button
                            type="text"
                            @click="item.showMore = true"
                            v-if="!item.showMore"
                            class="show-more"
                          >
                            更多
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                        </div>

                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.pubdate, "YYYY-MM-DD") }}
                          </span>
                          <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ clearHtml(item.applicantname.join(" ")) }}
                          </span>
                          <span class="b">
                            <img src="~@/assets/images/icon-tag.png" alt="" />
                            {{ item.pattypeText }}
                          </span>
                        </div>

                        <div class="op">
                          <el-button
                            @click="handleInsertText(clearHtml(item.abs))"
                          >
                            <img src="~@/assets/images/icon-quote.png" alt="" />
                          </el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        :key="index"
                        v-if="activeTextSearchName === 'zc'"
                      >
                        <div class="title">
                          <span class="type">政策</span>
                          <el-tooltip
                            placement="bottom-start"
                            effect="light"
                            :content="item.title"
                          >
                            <a href="javascript:void(0);">
                              {{ cutstring(item.title, 38) }}
                            </a>
                          </el-tooltip>
                        </div>

                        <div class="intro">
                          <span
                            v-text="clearHtml(item.fulltext)"
                            v-if="item.showMore"
                          ></span>
                          <span
                            v-text="cutstring(clearHtml(item.fulltext), 130)"
                            v-else
                          ></span>
                          <el-button
                            type="text"
                            @click="item.showMore = true"
                            v-if="!item.showMore"
                            class="show-more"
                          >
                            更多
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                        </div>

                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ item.publish_time }}
                          </span>
                          <span class="o" v-if="item.organ">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ item.organ.split(";").join(" ") }}
                          </span>
                          <span class="b">
                            <img src="~@/assets/images/icon-tag.png" alt="" />
                            {{ item.theme.split(";").join(" ") }}
                          </span>
                        </div>

                        <div class="op">
                          <el-button @click="handleInsertHtml(item.fulltext)">
                            <img src="~@/assets/images/icon-quote.png" alt="" />
                          </el-button>
                        </div>
                      </div>

                      <div
                        class="list-item"
                        :key="index"
                        v-if="activeTextSearchName === 'zx'"
                      >
                        <div class="title">
                          <span class="type">资讯</span>
                          <el-tooltip
                            placement="bottom-start"
                            effect="light"
                            :content="item.title"
                          >
                            <a href="javascript:void(0);">
                              {{ cutstring(item.title, 38) }}
                            </a>
                          </el-tooltip>
                        </div>

                        <div class="intro">
                          <span
                            v-text="item.abstract"
                            v-if="item.showMore"
                          ></span>
                          <span
                            v-text="cutstring(item.abstract, 130)"
                            v-else
                          ></span>
                          <el-button
                            type="text"
                            @click="item.showMore = true"
                            v-if="!item.showMore"
                            class="show-more"
                          >
                            更多
                            <i class="el-icon-arrow-down"></i>
                          </el-button>
                        </div>

                        <div class="info">
                          <span class="t">
                            <img src="~@/assets/images/icon-time.png" alt="" />
                            {{ dateFormat(item.publishTime, "YYYY-MM-DD") }}
                          </span>
                          <span class="o">
                            <img src="~@/assets/images/icon-from.png" alt="" />
                            {{ item.source.join(" ") }}
                          </span>
                          <span class="b">
                            <img src="~@/assets/images/icon-tag.png" alt="" />
                            {{ item.keyword.join(" ") }}
                          </span>
                        </div>

                        <div class="op">
                          <el-button @click="handleInsertHtml(item.content)">
                            <img src="~@/assets/images/icon-quote.png" alt="" />
                          </el-button>
                        </div>
                      </div>
                    </template>

                    <div
                      class="no-data"
                      v-if="!paragraphRecords || paragraphRecords.length === 0"
                    >
                      <div class="tip">
                        <svg
                          t="1626241932884"
                          class="icon"
                          viewBox="0 0 1428 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2321"
                          width="60"
                          height="60"
                        >
                          <path
                            d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                            p-id="2322"
                          ></path>
                          <path
                            d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                            p-id="2323"
                          ></path>
                          <path
                            d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                            p-id="2324"
                          ></path>
                          <path
                            d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                            p-id="2325"
                          ></path>
                          <path
                            d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                            p-id="2326"
                          ></path>
                          <path
                            d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                            p-id="2327"
                          ></path>
                        </svg>
                        <div class="text">暂无数据</div>
                      </div>
                    </div>
                  </div>
                  <div class="list-bottom" v-if="paragraphTotal > 0">
                    <el-pagination
                      small
                      layout="prev, pager, next"
                      :total="paragraphTotal"
                      :current-page="paragraphPageIndex"
                      @current-change="handleParagraphCurrentPageChange"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
              <div v-else-if="rightBarBox == 4" class="r-box">
                <div class="r-box_content">
                  <div class="inner-form">
                    <el-form size="small" label-width="5em">
                      <el-form-item label="数据类型">
                        <el-select
                          v-model="regionDataTag"
                          placeholder=""
                          :popper-class="'theme' + themeSelect + '-popper'"
                        >
                          <el-option
                            value="全国宏观年度库"
                            label="全国宏观年度库"
                          ></el-option>
                          <el-option
                            value="全国宏观月度库"
                            label="全国宏观月度库"
                          ></el-option>
                          <el-option
                            value="分省宏观年度库"
                            label="分省宏观年度库"
                          ></el-option>
                          <el-option
                            value="分省宏观月度库"
                            label="分省宏观月度库"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="区域范围">
                        <el-select
                          placeholder="请选择"
                          v-model="regionDataRegion"
                          :popper-class="'theme' + themeSelect + '-popper'"
                          v-if="
                            regionDataTag === '分省宏观年度库' ||
                            regionDataTag === '分省宏观月度库'
                          "
                        >
                          <el-option
                            v-for="(item, index) in regionNames"
                            :key="index"
                            :value="item"
                            :label="item"
                          ></el-option>
                        </el-select>
                        <el-select
                          placeholder="请选择"
                          v-model="regionDataRegion"
                          :popper-class="'theme' + themeSelect + '-popper'"
                          v-else
                        >
                          <el-option value="全国" label="全国"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="选择指标">
                        <!-- <el-input placeholder="" value="全国"></el-input> -->
                        <el-autocomplete
                          v-model="regionDataName"
                          :fetch-suggestions="queryRegionDataName"
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @keyup.native.enter="
                            (e) => {
                              e.preventDefault();
                            }
                          "
                        ></el-autocomplete>
                      </el-form-item>
                      <el-form-item
                        label="时间范围"
                        v-show="
                          regionDataTag === '分省宏观年度库' ||
                          regionDataTag === '分省宏观月度库'
                        "
                      >
                        <el-date-picker
                          v-model="regionDataDate"
                          type="monthrange"
                          range-separator="至"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份"
                          style="width: 100%"
                          format="yyyy年MM月"
                          size="mini"
                          unlink-panels
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item
                        label="时间范围"
                        v-show="
                          regionDataTag === '全国宏观年度库' ||
                          regionDataTag === '全国宏观月度库'
                        "
                      >
                        <el-date-picker
                          v-model="regionDataStartYear"
                          type="year"
                          :popper-class="'theme' + themeSelect + '-popper'"
                          placeholder="开始年"
                          format="yyyy年"
                        >
                        </el-date-picker>
                        至
                        <el-date-picker
                          v-model="regionDataEndYear"
                          type="year"
                          :popper-class="'theme' + themeSelect + '-popper'"
                          placeholder="结束年"
                          format="yyyy年"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item class="submit">
                        <el-button
                          type="primary"
                          @click.stop.native="handleRegionDataSearch()"
                        >
                          检索
                        </el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div
                    class="data-show"
                    v-if="regionDataTableNode && regionDataTableNode.length > 0"
                  >
                    <div class="graph w-e-text-container">
                      <div data-slate-editor v-html="regionDataTableHtml"></div>
                    </div>
                    <div class="bottom">
                      <el-radio-group v-model="dataType">
                        <el-radio label="1">表格</el-radio>
                      </el-radio-group>
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleInsertNodes(regionDataTableNode)"
                        >插入</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="rightBarBox == 5" class="r-box">
                <div class="r-box_content">
                  <div class="translate">
                    <div class="i-box">
                      <div class="i-box_title">
                        <h4>原文</h4>
                        <span class="op">
                          <el-select
                            size="mini"
                            :popper-class="'theme' + themeSelect + '-popper'"
                            placeholder=""
                            v-model="fySource"
                            @change="handleFanyiSourceChange"
                          >
                            <el-option
                              label="自动检测"
                              value="auto"
                            ></el-option>
                            <el-option label="中文" value="zh"></el-option>
                            <el-option label="英文" value="en"></el-option>
                          </el-select>
                        </span>
                      </div>
                      <div class="i-box_content">
                        <div class="input">
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 15 }"
                            rows="10"
                            v-model="fySourceText"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="i-box">
                      <div class="i-box_title">
                        <h4>译文</h4>
                        <span class="op">
                          <el-select
                            size="mini"
                            :popper-class="'theme' + themeSelect + '-popper'"
                            placeholder=""
                            v-model="fyType"
                            @change="handleFanyiTypeChange"
                          >
                            <el-option label="英文" value="en"></el-option>
                            <el-option label="中文" value="zh"></el-option>
                          </el-select>
                        </span>
                      </div>
                      <div class="i-box_content">
                        <div class="input">
                          <el-input
                            v-model="fyResultText"
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 15 }"
                            rows="10"
                            readonly
                          >
                          </el-input>
                          <div class="op">
                            <el-button
                              type="text"
                              @click="handleFanyiResultTextCopy"
                            >
                              <img
                                src="~@/assets/images/icon-copy.png"
                                alt=""
                              />
                              复制
                            </el-button>
                            <el-button
                              type="text"
                              @click="handleInsertText(fyResultText)"
                            >
                              <img
                                src="~@/assets/images/icon-insert.png"
                                alt=""
                              />
                              插入
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 封面选择 -->
    <el-dialog
      :visible.sync="dialogFrontCover"
      :append-to-body="true"
      :custom-class="'theme' + themeSelect + '-dialog'"
      width="900px"
    >
      <div class="dialog_title" slot="title">
        <span class="el-dialog__title">封面选择</span>
        <div class="inner-search">
          <el-input size="small" v-model="en" placeholder=" "
            ><i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input>
        </div>
      </div>
      <div class="dialog_content">
        <div class="cover-list">
          <div v-for="item in 12" :key="item" class="list-item">
            <div class="pic">
              <el-image :src="picSrc3"></el-image>
            </div>
            <div class="sel">
              <el-radio v-model="coverRadio" :label="item"></el-radio>
            </div>
          </div>
        </div>
        <div class="list-bottom">
          <el-pagination small layout="prev, pager, next" :total="50">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 目录选择 -->
    <el-dialog
      :visible.sync="dialogCatalog"
      :append-to-body="true"
      :custom-class="'theme' + themeSelect + '-dialog'"
      width="900px"
    >
      <div class="dialog_title" slot="title">
        <span class="el-dialog__title">目录选择</span>
        <div class="inner-search">
          <el-input
            size="small"
            v-model="chapterSearch"
            placeholder=""
            @keyup.native.enter="handleChapterSearch(true)"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="dialog_content">
        <div class="list-filter">
          <el-radio-group v-model="chapterLanguage">
            <el-radio :label="1">中英双语对照</el-radio>
            <el-radio :label="2">仅显示中文</el-radio>
            <el-radio :label="3">仅显示英语</el-radio>
          </el-radio-group>
        </div>
        <div class="catalog-list" v-loading="chapterLoading">
          <div
            v-for="(item, index) in chapterList"
            :key="index"
            class="list-item"
          >
            <el-checkbox
              v-model="checkbox"
              :label="item.id"
              border
              size="medium"
              @change="
                (checked) => {
                  handleChapterChange(checked, item.id);
                }
              "
            >
              {{ item.chapterName }}
            </el-checkbox>
          </div>
        </div>
        <div class="list-bottom">
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="chapterPageIndex"
            :page-size="chapterPageSize"
            :total="chapterTotal"
            @current-change="handleChapterCurrentPageChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 封底选择 -->
    <el-dialog
      :visible.sync="dialogBackCover"
      :append-to-body="true"
      :custom-class="'theme' + themeSelect + '-dialog'"
      width="900px"
    >
      <div class="dialog_title" slot="title">
        <span class="el-dialog__title">封底选择</span>
        <div class="inner-search">
          <el-input size="small" v-model="en" placeholder=" "
            ><i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input>
        </div>
      </div>
      <div class="dialog_content">
        <div class="cover-list">
          <div v-for="item in 12" :key="item" class="list-item">
            <div class="pic">
              <el-image :src="picSrc3"></el-image>
            </div>
            <div class="sel">
              <el-radio v-model="coverRadio" :label="item"></el-radio>
            </div>
          </div>
        </div>
        <div class="list-bottom">
          <el-pagination small layout="prev, pager, next" :total="50">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 设置 -->
    <el-dialog
      :visible.sync="dialogSetting"
      :append-to-body="true"
      :custom-class="'theme' + themeSelect + '-dialog'"
      width="900px"
    >
      <div class="dialog_title" slot="title">
        <span class="el-dialog__title">设置</span>
      </div>
      <div class="dialog_content">
        <div class="inner-title">
          <h4>主题模式</h4>
        </div>
        <div class="theme-select">
          <div class="theme-list">
            <div class="list-item">
              <div class="sel">
                <el-radio v-model="themeSelect" label="1"></el-radio>
              </div>
              <div class="pic">
                <el-image
                  :src="require('@/assets/images/theme1.png')"
                ></el-image>
              </div>
              <div class="name">浅色模式</div>
            </div>
            <div class="list-item">
              <div class="sel">
                <el-radio v-model="themeSelect" label="2"></el-radio>
              </div>
              <div class="pic">
                <el-image
                  :src="require('@/assets/images/theme2.png')"
                ></el-image>
              </div>
              <div class="name">深色色模式</div>
            </div>
          </div>
        </div>

        <!-- <div class="inner-title">
          <h4>主题模式</h4>
        </div>
        <div class="width-select">
          <div class="intro">
            固定宽度将使内容平铺到一张A4纸;设置自适应宽度后，文字宽度将适应页面宽度
          </div>
          <div>
            <el-radio v-model="widthSelect" label="1">固定宽度展示</el-radio>
            <el-radio v-model="widthSelect" label="2">自适应宽度</el-radio>
          </div>
        </div> -->
      </div>
    </el-dialog>

    <!-- 图片编辑 -->
    <el-dialog
      :title="imageEditorTitle"
      :visible.sync="dialogVisible"
      :before-close="handleImgEditorClose"
    >
      <div slot="title" class="dialog-title">
        <div style="position: absolute">
          <el-button type="primary" @click="handleImageEditorSave" size="mini">
            插入
          </el-button>
        </div>

        <div style="text-align: center; line-height: 28px">
          <span>{{ imageEditorTitle }}</span>
        </div>
      </div>

      <ImageEditor
        style="height: 800px"
        :loadImagePath="imageEditorPath"
        @saveBase64Image="handleSaveBase64Image"
        ref="imageEditor"
      ></ImageEditor>
    </el-dialog>
  </div>
</template>

<script>
import VipHeaderComposeDoc from "@/components/headerComposeDoc.vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {
  SlateEditor,
  SlateElement,
  SlateNode,
  SlateTransforms,
} from "@wangeditor/editor";
import { axiosRequest, axiosOptions } from "../../util/request.js";
import moment from "moment";
import ImageEditor from "@/components/imageEditor";
import { ungzip, gzip } from "../../util/compress";
import { cutstr } from "../../util/utils";
import { Message } from "element-ui";

import "swiper/css/swiper.css";
export default {
  components: { VipHeaderComposeDoc, Editor, Toolbar, ImageEditor },
  data() {
    return {
      listFilter: "1",
      checkbox: [],
      widthSelect: "1",
      themeSelect: "1",
      dialogCatalog: false,
      dialogCatalogShow: false,
      dialogSetting: false,
      coverRadio: "",
      dialogBackCover: false,
      dialogFrontCover: false,
      en: "",

      fySource: "auto",
      fySourceText: "",
      fyType: "en",
      fyResultText: "",

      rightBarBox: "",
      floatBarLayerShow: false,
      rightBarLayerShow: false,
      floatRadio: "1",
      picSrc1: require("@/assets/images/sample-pic3.png"),
      picSrc2: require("@/assets/images/sample-pic4.png"),
      picSrc3: require("@/assets/images/sample-pic1.png"),
      picSrc4: require("@/assets/images/sample-pic2.png"),
      picSrc5: require("@/assets/images/sample-pic5.png"),
      picSwiper: {
        slidesPerView: 1,
        spaceBetween: 15,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@0.50": {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          "@0.75": {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          "@1.00": {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      templateId: this.$route.query.template || 0,
      dataType: "1",
      loading: false,
      gbType: "",
      tabsCollapse: "",
      oldTabsCollapse: "",
      report: {
        type: "1",
        title: "",
        content: "",
      },
      reportType: "1",
      tabsActive: "1",
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: [
          "fullScreen",
          "emotion",
          "group-video",
          "todo",
          // "insertVideo",
          // "uploadVideo",
          // "editVideoSize", // 排除菜单组，写菜单组 key 的值即可
        ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server:
              `${process.env.VUE_APP_BASE_API}` +
              "/upload/upload-image-return-url",
            fieldName: "file",
            meta: {
              type: 0,
            },
            headers: {
              authorization: "Bearer " + localStorage.getItem("token"),
              "x-authorization":
                "Bearer " + localStorage.getItem("refreshToken"),
            },
            onFailed(file, res) {
              // console.log(`${file.name} 上传失败`, res);
              Message.error(res.message);
            },
          },
          insertImage: {
            onInsertedImage(imageNode) {
              // console.log(imageNode);
              if (imageNode == null) return;

              const { src, alt, url, href } = imageNode;
              // console.log("inserted image", src, alt, url, href);
            },
          },
          editImage: {
            onUpdatedImage(imageNode) {
              // console.log(imageNode);
              if (imageNode == null) return;

              const { src, alt, url } = imageNode;
              // console.log("updated image", src, alt, url);
            },
          },
        },
      },
      mode: "default", // or 'simple'
      paragraphLoading: false,
      paragraphText: "",
      paragraphPageIndex: 1,
      paragraphRecords: [],
      paragraphPages: -1,
      paragraphTotal: 0,
      activeTextSearchName: "yb",

      imageLoading: false,
      imageText: "",
      imagePageIndex: 1,
      imageRecords: [],
      imagePages: -1,
      imageTotal: 0,

      showHeader: true,
      headerHTML: "",

      type: null,
      title: "",

      dialogVisible: false,
      imageEditorPath: "",
      imageEditorTitle: "",

      subjectList: [],

      id: this.$route.query.id || 0,
      saveInterval: null,

      insertTimes: 3000,
      insertTimer: null,

      regionDataTag: "全国宏观年度库",
      regionDataRegion: "",
      regionDataName: "",
      regionDataDate: [],
      regionDataStartYear: null,
      regionDataEndYear: null,
      regionDataTableHtml: "",
      regionDataTableNode: [],

      oldHtmlContent: "",
      htmlContentSave: false,

      oldType: null,

      timer: null,

      chapterSearch: "",
      chapterList: [],
      chapterPageIndex: 1,
      chapterPageSize: 20,
      chapterTotal: 0,
      chapterLoading: false,
      chapterLanguage: 1,

      regionNames: [
        "北京市",
        "天津市",
        "河北省",
        "山西省",
        "内蒙古自治区",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "上海市",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "广西壮族自治区",
        "海南省",
        "重庆市",
        "四川省",
        "贵州省",
        "云南省",
        "西藏自治区",
        "陕西省",
        "甘肃省",
        "青海省",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
        // "台湾省",
        // "香港特别行政区",
        // "澳门特别行政区",
      ],
    };
  },
  // created() {
  //   this.getDetail();
  // },
  watch: {
    "$route.query"(newQuery) {
      this.templateId = newQuery.template;
      this.id = newQuery.id;
      this.title = "";
      this.html = "";
      this.editor.clear();
      this.getDetail();
    },
    fySourceText: {
      deep: true,
      handler(newVal, oldVal) {
        //延迟500ms
        this.debounce(this.handleFanyiInput, 500);
      },
    },
  },
  methods: {
    handleChapterChange(checked, id) {
      if (checked && id) {
        this.chapterLoading = true;
        axiosRequest(
          "/template/chapter-detail",
          { id: id, language: this.chapterLanguage },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data && res.data.code === 200) {
              this.handleInsertHtml(res.data.data);
            }
            this.chapterLoading = false;
          })
          .catch(() => {
            this.chapterLoading = false;
          });
      }
    },
    handleCatalogClick() {
      this.dialogCatalog = true;
      this.handleChapterSearch(true);
    },
    handleChapterCurrentPageChange(currentPage) {
      this.chapterPageIndex = currentPage;
      this.handleChapterSearch(false);
    },
    handleChapterSearch(resetPage) {
      this.chapterLoading = true;

      if (resetPage) {
        this.chapterPageIndex = 1;
      }

      axiosRequest(
        "/template/chapter-list",
        {
          name: this.chapterSearch || "",
          pageIndex: this.chapterPageIndex || 1,
          pageSize: this.chapterPageSize || 20,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.chapterList = res.data.data.records;
            this.chapterTotal = res.data.data.total;
          }
          this.chapterLoading = false;
        })
        .catch(() => {
          this.chapterLoading = false;
        });
    },
    clearHtml(val) {
      if (val) {
        return val.replace(/(<([^>]+)>)/gi, "");
      }

      return "";
    },
    handleTextSearchTabsClick(tab) {
      if (this.paragraphText) {
        this.handleTextSearch(true);
      }
    },
    handleTextSearch(resetPage) {
      this.paragraphRecords = [];
      this.paragraphPages = -1;
      this.paragraphTotal = 0;

      switch (this.activeTextSearchName) {
        case "yb":
          this.handleParagraphSearch(resetPage);
          break;
        case "lw":
          this.handlePaperParagraphSearch(resetPage);
          break;
        case "zl":
          this.handlePatentParagraphSearch(resetPage);
          break;
        case "zc":
          this.handlePolicyParagraphSearch(resetPage);
          break;
        case "zx":
          this.handleNewsParagraphSearch(resetPage);
          break;
      }
    },
    handlePaperParagraphSearch(resetPage) {
      if (!this.paragraphText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.paragraphPageIndex = 1;
      }

      this.getPaperParagraphMatch();
    },
    getPaperParagraphMatch() {
      this.paragraphLoading = true;
      axiosRequest(
        "/console/paper-paragraph-match",
        {
          text: this.paragraphText,
          pageIndex: this.paragraphPageIndex,
          pageSize: 5,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.paragraphLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.paragraphRecords = res.data.data.records;
            this.paragraphRecords = this.paragraphRecords.map((i) => {
              this.$set(i, "showMore", false);
              return i;
            });
            this.paragraphTotal = res.data.data.total;
          } else {
            this.paragraphRecords = [];
            this.paragraphPages = -1;
            this.paragraphTotal = 0;
          }
        })
        .catch(() => {
          this.paragraphLoading = false;
        });
    },
    handlePatentParagraphSearch(resetPage) {
      if (!this.paragraphText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.paragraphPageIndex = 1;
      }

      this.getPatentParagraphMatch();
    },
    getPatentParagraphMatch() {
      this.paragraphLoading = true;
      axiosRequest(
        "/patent/paragraph-match",
        {
          text: this.paragraphText,
          pageIndex: this.paragraphPageIndex,
          pageSize: 5,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.paragraphLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.paragraphRecords = res.data.data.results;
            this.paragraphRecords = this.paragraphRecords.map((i) => {
              this.$set(i, "showMore", false);
              return i;
            });
            this.paragraphTotal = res.data.data.totalCount;
          } else {
            this.paragraphRecords = [];
            this.paragraphPages = -1;
            this.paragraphTotal = 0;
          }
        })
        .catch(() => {
          this.paragraphLoading = false;
        });
    },
    handlePolicyParagraphSearch(resetPage) {
      if (!this.paragraphText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.paragraphPageIndex = 1;
      }

      this.getPolicyParagraphMatch();
    },
    getPolicyParagraphMatch() {
      this.paragraphLoading = true;
      axiosRequest(
        "/console/policy-paragraph-match",
        {
          text: this.paragraphText,
          pageIndex: this.paragraphPageIndex,
          pageSize: 5,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.paragraphLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.paragraphRecords = res.data.data.records;
            this.paragraphRecords = this.paragraphRecords.map((i) => {
              this.$set(i, "showMore", false);
              return i;
            });
            this.paragraphTotal = res.data.data.total;
          } else {
            this.paragraphRecords = [];
            this.paragraphPages = -1;
            this.paragraphTotal = 0;
          }
        })
        .catch(() => {
          this.paragraphLoading = false;
        });
    },
    handleNewsParagraphSearch(resetPage) {
      if (!this.paragraphText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.paragraphPageIndex = 1;
      }

      this.getNewsParagraphMatch();
    },
    getNewsParagraphMatch() {
      this.paragraphLoading = true;
      axiosRequest(
        "/console/news-paragraph-match",
        {
          text: this.paragraphText,
          pageIndex: this.paragraphPageIndex,
          pageSize: 5,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.paragraphLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.paragraphRecords = res.data.data.records;
            this.paragraphRecords = this.paragraphRecords.map((i) => {
              this.$set(i, "showMore", false);
              return i;
            });
            this.paragraphTotal = res.data.data.total;
          } else {
            this.paragraphRecords = [];
            this.paragraphPages = -1;
            this.paragraphTotal = 0;
          }
        })
        .catch(() => {
          this.paragraphLoading = false;
        });
    },
    //防抖
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    handleFanyiSourceChange(val) {
      switch (val) {
        case "zh":
          this.fyType = "en";
          break;
        case "en":
          this.fyType = "zh";
          break;
      }
      this.handleFanyiInput();
    },
    handleFanyiTypeChange(val) {
      switch (val) {
        case "zh":
          this.fySource = "en";
          break;
        case "en":
          this.fySource = "zh";
          break;
      }
      this.handleFanyiInput();
    },
    handleFanyiInput() {
      if (this.fySourceText) {
        axiosRequest(
          "/console/translation",
          { source: this.fySource, type: this.fyType, text: this.fySourceText },
          axiosOptions("post", "", "json")
        ).then((res) => {
          if (res.data && res.data.code === 200) {
            this.fySource = res.data.data.source;
            this.fyType = res.data.data.type;
            this.fyResultText = res.data.data.tl;
          }
        });
      } else {
        this.fyResultText = "";
      }
    },
    handleFanyiResultTextCopy() {
      if (this.fyResultText) {
        const that = this;
        this.$copyText(this.fyResultText).then(
          function (e) {
            that.$message.success("已复制到剪切板");
          },
          function (e) {
            that.$message.error("复制失败！");
          }
        );
      }
    },
    showTips() {
      this.$message.warning("功能开发中...");
    },
    handleTitleChange(val) {
      this.title = val;
    },
    onCopySuccess() {
      this.$message.success("复制成功！");
    },
    onCopyError() {
      this.$message.success("复制失败！");
    },
    handleRegionDataSearch() {
      if (!this.regionDataName) {
        this.$message.warning("请选择指标");
        return;
      }

      let startYearCode = "",
        endYearCode = "";
      if (
        this.regionDataTag === "全国宏观年度库" ||
        this.regionDataTag === "全国宏观月度库"
      ) {
        if (this.regionDataStartYear) {
          startYearCode =
            this.dateFormat(this.regionDataStartYear, "yyyy") + "00";
        }
        if (this.regionDataEndYear) {
          endYearCode = this.dateFormat(this.regionDataEndYear, "yyyy") + "00";
        }
      } else {
        if (this.regionDataDate && this.regionDataDate.length > 0) {
          startYearCode = this.dateFormat(this.regionDataDate[0], "yyyyMM");
        }
        if (this.regionDataDate && this.regionDataDate.length > 1) {
          endYearCode = this.dateFormat(this.regionDataDate[1], "yyyyMM");
        }
      }

      axiosRequest(
        "/search/region-data-table-match",
        {
          text: this.regionDataName,
          region: this.regionDataRegion || "全国",
          tag: this.regionDataTag,
          startYearCode: startYearCode,
          endYearCode: endYearCode,
          pageIndex: 1,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data.code === 200) {
            // console.log(res.data.data);

            if (res.data.data.records && res.data.data.records.length > 0) {
              let yearCodeList = [],
                records = [];
              res.data.data.records.forEach((item) => {
                let findIndex = yearCodeList.findIndex(
                  (i) => i === item.yearCode
                );
                if (findIndex < 0 && item.strdata) {
                  yearCodeList.push(item.yearCode);
                  records.push(item);
                }
              });
              res.data.data.records = records;

              // res.data.data.records = res.data.data.records.filter(
              //   (item) => item.strdata
              // );
              // let yearCodeList = res.data.data.records.map(
              //   (item) => item.yearCode
              // );
              //yearCodeList = Array.from(new Set(yearCodeList));

              let tableCells = [];
              let tableRows = [];
              tableRows.push({
                type: "table-row",
                children: [
                  {
                    type: "table-cell",
                    isHeader: true,
                    colSpan: 1,
                    rowSpan: 2,
                    width: "auto",
                    children: [{ text: "地区" }],
                  },
                  {
                    type: "table-cell",
                    isHeader: true,
                    colSpan: yearCodeList.length,
                    rowSpan: 1,
                    width: "auto",
                    children: [{ text: "时间" }],
                  },
                ],
              });

              let theadHtml = "";
              yearCodeList.forEach((yearCode) => {
                let year = yearCode.substring(0, 4);
                let month = yearCode.substring(4);
                let dateStr = year + "年";
                if (month && month !== "00") {
                  dateStr += month + "月";
                }

                theadHtml +=
                  "<th colSpan='1' rowSpan='1' width='auto'>" +
                  dateStr +
                  "</th>";
                tableCells.push({
                  type: "table-cell",
                  isHeader: true,
                  colSpan: 1,
                  rowSpan: 1,
                  width: "auto",
                  children: [{ text: dateStr }],
                });
              });
              tableRows.push({ type: "table-row", children: tableCells });

              let tableUnit = "";
              tableCells = [];
              let tbodyHtml = "";
              const regionList = res.data.data.records.map(
                (item) => item.region
              );
              //去重
              const distinctRegionList = Array.from(new Set(regionList));
              distinctRegionList.forEach((region) => {
                const currentList = res.data.data.records.filter(
                  (item) => item.region === region
                );
                tbodyHtml +=
                  "<tr><td colSpan='1' rowSpan='1' width='auto'>" +
                  region +
                  "</td>";
                tableCells.push({
                  type: "table-cell",
                  isHeader: false,
                  colSpan: 1,
                  rowSpan: 1,
                  width: "auto",
                  children: [{ text: region }],
                });
                currentList.forEach((item) => {
                  if (item.strdata) {
                    if (!tableUnit) {
                      tableUnit = item.unit;
                    }

                    tbodyHtml +=
                      "<td colSpan='1' rowSpan='1' width='auto'>" +
                      item.strdata +
                      "</td>";
                    tableCells.push({
                      type: "table-cell",
                      isHeader: false,
                      colSpan: 1,
                      rowSpan: 1,
                      width: "auto",
                      children: [{ text: item.strdata }],
                    });
                  } else {
                    tbodyHtml +=
                      "<td colSpan='1' rowSpan='1' width='auto'>-</td>";
                    tableCells.push({
                      type: "table-cell",
                      isHeader: false,
                      colSpan: 1,
                      rowSpan: 1,
                      width: "auto",
                      children: [{ text: "-" }],
                    });
                  }
                });
                tbodyHtml += "</tr>";
                tableRows.push({ type: "table-row", children: tableCells });
              });

              this.regionDataTableHtml =
                "<p style='text-align: center;'>" +
                this.regionDataName +
                "（" +
                tableUnit +
                "）</p>" +
                "<table style='width: auto;'><tbody><tr><th colSpan='1' rowSpan='2' width='auto'>地区</th><th colSpan='" +
                yearCodeList.length +
                "' rowSpan='1' width='auto'>时间</th></tr>";
              this.regionDataTableHtml +=
                theadHtml + tbodyHtml + "</tbody></table>";

              this.regionDataTableNode = [
                {
                  type: "paragraph",
                  textAlign: "center",
                  children: [
                    { text: this.regionDataName + "（" + tableUnit + "）" },
                  ],
                },
                {
                  type: "table",
                  width: "auto",
                  children: tableRows,
                },
              ];
            }
          }
        })
        .catch(() => {});
    },
    handleInsertNodes(nodes) {
      if (!this.editor.isFocused()) {
        // this.editor.focus();
        this.editor.restoreSelection();
      }
      //this.editor.insertNode(nodes);
      SlateTransforms.insertNodes(this.editor, nodes);
      this.editor.move(1);
      this.editor.insertBreak();
      this.editor.moveReverse(1);
    },
    queryRegionDataName(queryString, cb) {
      // console.log(queryString);

      if (queryString) {
        axiosRequest(
          "/search/region-data-name-match",
          { text: queryString },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data.code === 200) {
              if (res.data.data.cname_count) {
                const list = [];
                res.data.data.cname_count.forEach((item) => {
                  list.push({ value: item.key });
                });
                cb(list);
              }
            }
          })
          .catch(() => {});
      }
    },
    handleSelectRegionDataName(item) {
      if (item && item.value) {
        axiosRequest(
          "/search/region-data-table-match",
          { text: item.value, pageIndex: 1 },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data.code === 200) {
              // console.log(res.data.data);

              if (res.data.data.records && res.data.data.records.length > 0) {
                res.data.data.records = res.data.data.records.filter(
                  (item) => item.strdata
                );
                const yearCodeList = res.data.data.records.map(
                  (item) => item.yearCode
                );

                let tableCells = [];
                let tableRows = [];
                tableRows.push({
                  type: "table-row",
                  children: [
                    {
                      type: "table-cell",
                      isHeader: true,
                      colSpan: 1,
                      rowSpan: 2,
                      width: "auto",
                      children: [{ text: "地区" }],
                    },
                    {
                      type: "table-cell",
                      isHeader: true,
                      colSpan: yearCodeList.length,
                      rowSpan: 1,
                      width: "auto",
                      children: [{ text: "时间" }],
                    },
                  ],
                });

                let theadHtml = "";
                yearCodeList.forEach((yearCode) => {
                  let year = yearCode.substring(0, 4);
                  let month = yearCode.substring(4);
                  let dateStr = year + "年";
                  if (month && month !== "00") {
                    dateStr += month + "月";
                  }

                  theadHtml +=
                    "<th colSpan='1' rowSpan='1' width='auto'>" +
                    dateStr +
                    "</th>";
                  tableCells.push({
                    type: "table-cell",
                    isHeader: true,
                    colSpan: 1,
                    rowSpan: 1,
                    width: "auto",
                    children: [{ text: dateStr }],
                  });
                });
                tableRows.push({ type: "table-row", children: tableCells });

                let tableUnit = "";
                tableCells = [];
                let tbodyHtml = "";
                const regionList = res.data.data.records.map(
                  (item) => item.region
                );
                //去重
                const distinctRegionList = Array.from(new Set(regionList));
                distinctRegionList.forEach((region) => {
                  const currentList = res.data.data.records.filter(
                    (item) => item.region === region
                  );
                  tbodyHtml +=
                    "<tr><td colSpan='1' rowSpan='1' width='auto'>" +
                    region +
                    "</td>";
                  tableCells.push({
                    type: "table-cell",
                    isHeader: false,
                    colSpan: 1,
                    rowSpan: 1,
                    width: "auto",
                    children: [{ text: region }],
                  });
                  currentList.forEach((item) => {
                    if (item.strdata) {
                      if (!tableUnit) {
                        tableUnit = item.unit;
                      }

                      tbodyHtml +=
                        "<td colSpan='1' rowSpan='1' width='auto'>" +
                        item.strdata +
                        "</td>";
                      tableCells.push({
                        type: "table-cell",
                        isHeader: false,
                        colSpan: 1,
                        rowSpan: 1,
                        width: "auto",
                        children: [{ text: item.strdata }],
                      });
                    } else {
                      tbodyHtml +=
                        "<td colSpan='1' rowSpan='1' width='auto'>-</td>";
                      tableCells.push({
                        type: "table-cell",
                        isHeader: false,
                        colSpan: 1,
                        rowSpan: 1,
                        width: "auto",
                        children: [{ text: "-" }],
                      });
                    }
                  });
                  tbodyHtml += "</tr>";
                  tableRows.push({ type: "table-row", children: tableCells });
                });

                this.regionDataTableHtml =
                  "<p style='text-align: center;'>" +
                  item.value +
                  "（" +
                  tableUnit +
                  "）</p>" +
                  "<table style='width: auto;'><tbody><tr><th colSpan='1' rowSpan='2' width='auto'>地区</th><th colSpan='" +
                  yearCodeList.length +
                  "' rowSpan='1' width='auto'>时间</th></tr>";
                this.regionDataTableHtml +=
                  theadHtml + tbodyHtml + "</tbody></table>";

                this.regionDataTableNode = [
                  {
                    type: "paragraph",
                    textAlign: "center",
                    children: [{ text: item.value + "（" + tableUnit + "）" }],
                  },
                  {
                    type: "table",
                    width: "auto",
                    children: tableRows,
                  },
                ];
              }
            }
          })
          .catch(() => {});
      }
    },
    // handleTypechange(val) {
    //   this.$confirm("切换模板后内容将被替换，是否继续？", "警告")
    //     .then(() => {
    //       this.oldType = val;
    //       const checkedItem = this.subjectList.find((item) => item.id == val);
    //       if (checkedItem) {
    //         this.html = checkedItem.template;
    //         if (!this.html) {
    //           this.editor.clear();
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       this.type = this.oldType;
    //     });
    // },
    cutstring(str, len) {
      return cutstr(str, len);
    },
    handleSave() {
      if (!this.title) {
        this.$message.warning("请输入标题！");
        return;
      }

      this.save(true).then(() => {
        this.$message.success("保存成功！");
      });
    },
    async save(isDefault) {
      const content = this.editor.getHtml();
      if (this.title && content) {
        if (
          !this.htmlContentSave &&
          (!this.oldHtmlContent || this.oldHtmlContent !== content)
        ) {
          this.htmlContentSave = true;
          gzip(content).then(async (gzipStr) => {
            await axiosRequest(
              "/user-report/save",
              {
                id: !isDefault ? 0 : this.id || 0,
                templateId: this.templateId,
                type: isDefault ? 0 : 1,
                title: this.title,
                content: gzipStr,
              },
              axiosOptions("post", "", "json")
            )
              .then((res) => {
                this.htmlContentSave = false;
                if (res.data && res.data.code === 200) {
                  this.$refs.headerComposeDoc.changeSaveTime();
                  this.oldHtmlContent = content;
                  if (res.data.data > 0) {
                    this.id = res.data.data;
                  }
                }
              })
              .catch(() => {
                this.htmlContentSave = false;
              });
          });
        }
      }
    },
    getDetail() {
      if (this.id) {
        this.loading = true;
        axiosRequest(
          "/user-report/detail",
          { id: this.id },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            if (res.data && res.data.code === 200) {
              this.templateId = res.data.data.templateId;
              this.title = res.data.data.title;
              this.$refs.headerComposeDoc.changeTitle(this.title);
              ungzip(res.data.data.content).then((html) => {
                this.loading = false;
                // this.html = html;
                try {
                  const nodes = JSON.parse(html);
                  if (nodes && nodes.length > 0) {
                    SlateTransforms.insertNodes(this.editor, nodes);
                  } else {
                    this.editor.dangerouslyInsertHtml(html);
                  }
                } catch (error) {
                  this.editor.dangerouslyInsertHtml(html);
                }
              });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (this.templateId) {
        this.loading = true;
        axiosRequest(
          "/template/detail",
          { id: this.templateId },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            this.loading = false;
            if (res.data && res.data.code === 200) {
              // this.html = res.data.data;
              this.editor.dangerouslyInsertHtml(res.data.data);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },
    handleShowHeader() {
      this.showHeader = !this.showHeader;
    },
    handleSaveBase64Image(base64String) {
      this.handleInsertImg(base64String);
      this.handleImgEditorClose();
    },
    handleImageEditorSave() {
      let base64String = this.$refs.imageEditor.instance.toDataURL();
      this.handleInsertImg(base64String);
      this.handleImgEditorClose();
    },
    handleExport(type) {
      if (!this.title) {
        this.$message.warning("请输入标题！");
        return;
      }
      const content = this.editor.getText();
      if (!content) {
        this.$message.warning("内容不能为空！");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let url = `${process.env.VUE_APP_BASE_API}/console/document-export`;

      const that = this;
      const xhr = new XMLHttpRequest();
      xhr.open("post", url, true);
      xhr.responseType = "arraybuffer";
      xhr.setRequestHeader(
        "authorization",
        "Bearer " + localStorage.getItem("token")
      );
      xhr.setRequestHeader(
        "x-authorization",
        "Bearer " + localStorage.getItem("refreshToken")
      );

      xhr.setRequestHeader("content-type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            loading.close();
            try {
              let filename = "";
              let disposition = this.getResponseHeader("content-disposition");
              let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              let matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = decodeURIComponent(
                  matches[1].replace(/['"]/g, "").substring(5)
                );
              }

              let filetype = "";
              let fileext = filename.substring(filename.lastIndexOf("."));
              switch (fileext) {
                case ".pdf":
                  filetype = "application/pdf";
                  break;
                case "doc":
                  filetype = "application/msword";
                  break;
                case "docx":
                  filetype =
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                  break;
                case ".xls":
                  filetype = "application/vnd.ms-excel";
                  break;
                case ".xlsx":
                  filetype =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                  break;
              }

              let blob = new Blob([xhr.response], {
                type: filetype,
              });
              if (window.navigator && window.navigator.msSaveBlob) {
                // deal with IE 11, data是第一步toBlob的结果值
                window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(link.href);
              }
            } catch {
              that.$message.error("下载失败，请稍后重试");
            }
          }
        } else if (this.status === 401) {
          loading.close();
          localStorage.removeItem("token");
          localStorage.removeItem("logined");
          that.$store.commit("setLogined", false);
          //   location.href = "/login";
          that.$router.push(
            "/login?returnUrl=" +
              encodeURIComponent(that.$router.currentRoute.fullPath)
          );
        }
      };
      xhr.send(
        JSON.stringify({
          title: this.title,
          html: this.editor.getHtml(),
          type: type,
        })
      );
    },
    handleInsertText(content) {
      if (!content) {
        return;
      }

      // console.log(content);
      if (!this.editor.isFocused()) {
        //this.editor.focus();
        this.editor.restoreSelection();
      }

      let that = this;
      let index = 0;
      const myFunction = function () {
        //clearInterval(that.insertTimer);

        //计算插入的文字数量
        let insertLen = parseInt((content.length * 10) / that.insertTimes);
        if ((content.length * 10) % that.insertTimes > 0) {
          insertLen += 1;
        }
        if (!insertLen || insertLen < 1) {
          insertLen = 1;
        }

        //截取1毫秒插入的文本
        let insertContent = content.substring(
          index * insertLen,
          (index + 1) * insertLen
        );

        if (insertContent) {
          //that.insertInterval = Math.random() * 500;
          that.editor.insertText(insertContent);
          index++;
          //that.insertTimer = setInterval(myFunction, 10);
        } else {
          that.editor.insertBreak();
          clearInterval(that.insertTimer);
          that.insertTimer = null;
          index = 0;
        }
      };
      that.insertTimer = setInterval(myFunction, 10);

      // this.editor.insertText(content);
      // this.editor.insertBreak();
    },
    //handleParagraph(e, getText) {
    handleParagraph(getText) {
      //e.stopPropagation();

      this.tabsCollapse = "3";

      if (getText) {
        this.paragraphText = this.getParagraphText();
      } else {
        this.paragraphPageIndex++;
      }

      if (
        (this.paragraphPages === -1 ||
          this.paragraphPageIndex < this.paragraphPages) &&
        this.paragraphText
      ) {
        this.getParagraphMatch();
      }
    },
    getParagraphText() {
      this.editor.restoreSelection();
      let text = this.editor.getSelectionText();

      if (!text) {
        const nodeEntries = SlateEditor.nodes(this.editor, {
          match: (node) => {
            // console.log(node);
            if (SlateElement.isElement(node)) {
              if (node.type === "paragraph") {
                return true; // 匹配 paragraph
              } else if (node.type.indexOf("header") > -1) {
                return true; // 匹配 header
              }
            }
            return false;
          },
          universal: true,
        });

        if (nodeEntries) {
          for (let nodeEntry of nodeEntries) {
            const [node, path] = nodeEntry;
            if (node && node.children && node.children.length > 0) {
              node.children.forEach((element) => {
                // console.log(element.text);
                text += element.text;
              });
            }
            // console.log("选中了 paragraph 节点", node);
            // console.log("节点 path 是", path);
          }
        }
      }

      return text;
    },
    handleParagraphSearch(resetPage) {
      if (!this.paragraphText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.paragraphPageIndex = 1;
      }

      this.getParagraphMatch();
    },
    handleParagraphCurrentPageChange(currentPage) {
      this.paragraphPageIndex = currentPage;
      this.handleTextSearch(false);
      // this.handleParagraphSearch(false);
    },
    getParagraphMatch() {
      this.paragraphLoading = true;
      axiosRequest(
        "/search/paragraph-match",
        { text: this.paragraphText, pageIndex: this.paragraphPageIndex },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.paragraphLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.paragraphRecords = res.data.data.records;
            this.paragraphRecords = this.paragraphRecords.map((i) => {
              this.$set(i, "showMore", false);
              return i;
            });
            // res.data.data.records.forEach((element) => {
            //   this.paragraphRecords.push(element);
            // });
            this.paragraphPages = res.data.data.pages;
            this.paragraphTotal = res.data.data.total;
          } else {
            this.paragraphRecords = [];
            this.paragraphPages = -1;
            this.paragraphTotal = 0;
          }
        })
        .catch(() => {
          this.paragraphLoading = false;
        });
    },

    handleInsertHtml(html) {
      // console.log(html);
      if (!this.editor.isFocused()) {
        //this.editor.focus();
        this.editor.restoreSelection();
      }
      //this.editor.setHtml(html);
      this.editor.dangerouslyInsertHtml(html);
      this.editor.insertBreak();
    },
    handleOpenEditImg(url, title) {
      this.imageEditorPath = url;
      this.imageEditorTitle = title;
      document.documentElement.style.overflowY = "hidden";
      this.dialogVisible = true;
    },
    handleImgEditorClose() {
      document.documentElement.style.overflowY = "auto";
      this.dialogVisible = false;
    },
    handleInsertImg(url) {
      this.handleInsertHtml(`<img src="${url}" alt="" />`);
    },
    //handleImage(e, getText) {
    handleImage(getText) {
      //e.stopPropagation();

      this.tabsCollapse = "4";

      if (getText) {
        this.imageText = this.getParagraphText();
      } else {
        this.imagePageIndex++;
      }

      if (
        (this.imagePages === -1 || this.imagePageIndex < this.imagePages) &&
        this.imageText
      ) {
        this.getImageMatch();
      }
    },
    handleImageSearch(resetPage) {
      if (!this.imageText) {
        this.$message.error("请输入检索词");
        return;
      }

      if (resetPage) {
        this.imagePageIndex = 1;
      }

      this.getImageMatch();
    },
    handleImageCurrentPageChange(currentPage) {
      this.imagePageIndex = currentPage;
      this.handleImageSearch(false);
    },
    getImageMatch() {
      this.imageLoading = true;
      axiosRequest(
        "/search/image-match",
        { text: this.imageText, pageIndex: this.imagePageIndex },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.imageLoading = false;
          if (res.data && res.data.code === 200 && res.data.data) {
            this.imageRecords = res.data.data.records;
            // res.data.data.records.forEach((element) => {
            //   this.imageRecords.push(element);
            // });
            this.imagePages = res.data.data.pages;
            this.imageTotal = res.data.data.total;
          } else {
            this.imageRecords = [];
            this.imagePages = -1;
            this.imageTotal = 0;
          }
        })
        .catch(() => {
          this.imageLoading = false;
        });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错

      this.getDetail();

      // console.log(DomEditor);
      // const toolbar = DomEditor.getToolbar(this.editor);
      // const curToolbarConfig = toolbar.getConfig();
      // console.log(curToolbarConfig.toolbarKeys); // 当前菜单排序和分组
      //console.log(this.editor.getAllMenuKeys());
    },
    onChange(editor) {
      const headers = editor.getElemsByTypePrefix("header");
      this.headerHTML = headers
        .map((header) => {
          const text = SlateNode.string(header);
          const { id, type } = header;
          return `<li data-id="${id}" type="${type}">${text}</li>`;
        })
        .join("");
    },
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = "<p>模拟 Ajax 异步设置内容 HTML</p>";
    // }, 1500);

    // 标题 DOM 容器
    const headerContainer = document.getElementById("header-container");
    headerContainer.addEventListener("click", (event) => {
      if (event.target.tagName !== "LI") return;
      event.preventDefault();
      const id = event.target.getAttribute("data-id"); //event.target.id;
      // this.editor.scrollToElem(id); // 滚动到标题
      let item = document.getElementById(id); // 指定的元素
      let wrapper = document.getElementById("page"); // 其父元素 - 必须是产生滚动条的元素
      // 父组件滚动法
      wrapper.scrollTo({
        top: item.offsetTop,
        behavior: "smooth",
      });
    });

    setTimeout(() => {
      if (!this.saveInterval) {
        this.saveInterval = setInterval(this.save, 1000 * 60 * 3);
      }
    }, 1000 * 60 * 3);
  },
  beforeDestroy() {
    if (this.saveInterval) {
      clearInterval(this.saveInterval);
    }

    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/compose.scss";

::v-deep .w-e-text-container {
  [data-slate-editor] table th {
    white-space: nowrap;
  }
}

::v-deep .catalog {
  padding: 20px;

  li {
    padding: 6px 0;
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    cursor: pointer;
  }
  li[type="header2"] {
    text-indent: 2em;
  }
  li[type="header3"] {
    text-indent: 4em;
  }
  li[type="header4"] {
    text-indent: 6em;
  }
  li[type="header5"] {
    text-indent: 8em;
  }
}

.translate ::v-deep .input {
  .op {
    bottom: 5px !important;
  }
}

.article-list {
  .intro {
    max-height: unset !important;
    -webkit-line-clamp: unset !important;

    .show-more {
      float: right;
      padding-top: 3px !important;
    }
  }
}
</style>
